const failure = (reason, message) => ({ ok: false, reason, message });

export function createNotificationAcknowledgement({
  fetchFn,
  isStaleNotificationId,
  getClientIdHeader = () => ({}),
}) {
  const acknowledge = async (ids) => {
    if (!Array.isArray(ids)) {
      return failure('invalid-ids', 'Stale notification IDs must be an array.');
    }

    const acknowledgedIds = [...new Set(ids)];
    if (
      acknowledgedIds.length === 0
      || acknowledgedIds.some((id) => !isStaleNotificationId(id))
    ) {
      return failure('invalid-ids', 'Only received stale notification IDs can be acknowledged.');
    }

    let response;
    try {
      response = await fetchFn('/api/v1/messages/ack/', {
        credentials: 'same-origin',
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...getClientIdHeader(),
        },
        body: JSON.stringify({ ids: acknowledgedIds }),
      });
    } catch (error) {
      return failure('network', error instanceof Error ? error.message : 'The acknowledgement request failed.');
    }

    if (!response?.ok) {
      return failure('http', `The acknowledgement request failed with status ${response?.status ?? 'unknown'}.`);
    }

    let payload;
    try {
      payload = await response.json();
    } catch {
      return failure('malformed-response', 'The acknowledgement response was not valid JSON.');
    }

    if (!payload || typeof payload !== 'object' || payload.ok !== true) {
      return failure('malformed-response', 'The acknowledgement response was not recognized.');
    }

    return { ok: true, acknowledgedIds };
  };

  return { acknowledge };
}
